<template lang="pug">
v-card(:max-width="maxWidth").suus__avatar-card
    v-list-item(@click="goToUrl")
        v-list-item-avatar(color="primary")
            v-img(
                :alt="this.name"
                :src="avatarUrl"
            )
                template(v-slot:placeholder)
                    AvatarPlaceholder(:avatarType="avatarType")

        v-list-item-content.px-2
            v-list-item-title.suus__avatar-card__title.mb-0 {{ name }}
            v-list-item-subtitle(v-if="subtitle")
                .suus__avatar-card__subtitle.d-flex.align-center
                    slot(name="subtitle") {{ subtitle }}
        v-list-item-action.suus__avatar-card__action.pl-4
            v-btn(
              icon
              @click.stop="emitEdit"
              v-if="isEditable"
            )
                v-icon(left, color="textColor", :size="22") {{ editIcon }}
            a(
                @click.stop
                :href="contactData.href"
            ).d-flex.flex-column
                v-icon(color="textColor") {{ contactData.icon }}
                span.suus__action-label {{ contactData.label }}
</template>

<script lang="ts">
import Vue, { PropType } from "vue"
import AvatarPlaceholder from "../UI/AvatarPlaceholder.vue"
import {mdiEmailSendOutline, mdiPen, mdiPencil} from "@mdi/js"
import { mdiPhoneOutgoingOutline } from "@mdi/js"
import { mdiArrowTopRight } from "@mdi/js"
import Button from "components/UI/Button.vue";

export default Vue.extend({
  name: "AvatarCard",
  components: {Button, AvatarPlaceholder },
  props: {
    email: String,
    phone: String,
    name: String,
    avatarUrl: String,
    isEditable: {type:Boolean, default: false},
    url: String,
    maxWidth: { type: String, default: "350" },
    subtitle: { type: [String, Boolean], default: false },
    avatarType: {
      type: String,
      default: "GroupMember",
      validator: (val: string) => ["GroupMember", "Group"].includes(val),
    },
  },
  computed: {
    isMobile(): boolean {
      return this.$vuetify.breakpoint.mobile
    },
    contactData(): object {
      if (
        (this.email && this.phone && this.isMobile) ||
        (!this.email && this.phone)
      ) {
        return {
          href: `tel:${this.phone}`,
          icon: mdiPhoneOutgoingOutline,
          label: "Tel",
        }
      }
      if (!this.isMobile && this.email) {
        return {
          href: `mailto:${this.email}`,
          icon: mdiEmailSendOutline,
          label: "E-Mail",
        }
      }
      return {
        href: this.url,
        icon: mdiArrowTopRight,
        label: "Profil",
      }
    },
  },
  methods: {
    goToUrl(event) {
      if (this.url) window.location.href = `${this.url}`
    },
    emitEdit() {
      this.$emit("edit")
    },
  },
  data(){
    return{
      editIcon: mdiPencil
    }
  }
})
</script>

<style lang="sass" scoped>
$text-color: rgba(66, 66, 66, 1)
%font-stack
    font-family: system-ui !important
    color: $text-color
.suus__avatar-card
    &__title
        @extend %font-stack
        font-size: 1rem !important
        font-weight: 700 !important
        color: $text-color
    &__subtitle
        @extend %font-stack
        font-size: 0.9rem
        font-weight: 700 !important
        color: #727272
        line-height: normal !important
        margin-top: 1px
    &__action
        border-left: 1px solid #EDEDED !important
        display: flex
        flex-direction: row
        align-items: center
        justify-content: center
    .suus__action-label
        @extend %font-stack
        font-weight: 700 !important
        font-size: 0.8rem !important
        text-transform: uppercase
        letter-spacing: 0 !important
        color: $text-color
</style>
